import { Email, Lock, Logout, MenuBook, Phone } from "@mui/icons-material";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import { Button, Grid, Skeleton, useMediaQuery, useTheme } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { SiteLogo } from "../assets/img/icons/Logo";
import logo from "../assets/img/logo.png";
import { AdContext } from "../context/AdContext";
import { useAuth } from "../hooks/useAuth";
import { ICategory } from "../interfaces/ICategory";
import { ISetting } from "../interfaces/ISetting";
import axios from "../utils/AxiosUtil";
import SideBar from "./SideBar";
type IHeader = {
  categories: ICategory[];
  slug: string;
  setting?: ISetting;
  isLoading: boolean;
};
const Header: React.FC<IHeader> = ({ categories, setting, isLoading }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const { authState, handleLogout } = useAuth();
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const logout = async () => {
    try {
      const { data } = await axios.get("/logout");
      handleLogout();
      console.log("data", data);
    } catch (e: any) {
      console.log("error", e);
    }
  };

  const { ads } = React.useContext(AdContext);
  const banner = ads.find((item) => item.ad_category.slug == "header-banner");

  return (
    <Box>
      <Helmet>
        <title>
          Do-Follow Social Bookmarking Sites | Social Bookmarking Submission
          Sites
        </title>
      </Helmet>
      <Grid
        container
        className="header-info"
        direction="row"
        alignItems="center"
        p={1}
      >
        <Grid item xs={6} p={1} className="flex text-black">
          <p className="text-sm md:text-base flex items-center">
            <Email fontSize="small" />
            {isLoading ? (
              <Skeleton sx={{ ml: 1 }} variant="text" width={100} />
            ) : (
              <span className="pl-2">{setting?.primary_email}</span>
            )}
          </p>
          <p className="pl-2 hidden lg:flex xl:flex items-center">
            <Phone fontSize="small" />
            {isLoading ? (
              <Skeleton sx={{ ml: 1 }} variant="text" width={100} />
            ) : (
              <span className="pl-2">
                {setting?.phone1}
                {setting?.phone2 ? `, ${setting.phone2}` : ""}
              </span>
            )}
          </p>
        </Grid>
        <Grid item xs={6} className="flex items-center justify-end">
          {!authState?.token && (
            <Link to="/signup">
              <Button
                size="small"
                variant={smallScreen ? "text" : "contained"}
                color="primary"
              >
                SignUp
              </Button>
            </Link>
          )}
          {!authState?.token && (
            <Link to="/login">
              <Button
                sx={{ ml: 2 }}
                size="small"
                variant={smallScreen ? "text" : "contained"}
                color="primary"
              >
                Login
              </Button>
            </Link>
          )}
          {authState?.token && (
            <Link to="/post-story">
              <Button
                sx={{ ml: 2 }}
                size="small"
                variant={smallScreen ? "text" : "contained"}
                color="primary"
              >
                Post Story
              </Button>
            </Link>
          )}
          {authState?.token && (
            <Button
              size="small"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              color="inherit"
              sx={{
                ml: 2,
                display: { lg: "block", md: "block", sm: "none", xs: "none" },
              }}
              onClick={handleMenu}
            >
              {authState?.userInfo?.name} <AccountCircle sx={{ ml: 2 }} />
            </Button>
          )}
        </Grid>
      </Grid>
      <Box sx={{ display: { lg: "none", md: "none" } }}>
        <AppBar
          elevation={0}
          position="static"
          sx={{ display: { lg: "none", md: "none" } }}
        >
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ display: { lg: "none", md: "none" } }}
                onClick={() => setOpen(true)}
              >
                <MenuIcon />
              </IconButton>
              <Link to="/">
                <SiteLogo sx={{ width: 100, height: 30 }} />
              </Link>
            </Box>
            <div>
              {authState?.token && (
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  color="inherit"
                  onClick={handleMenu}
                >
                  <AccountCircle />
                </IconButton>
              )}
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <Link to="/profile">
                  <MenuItem>
                    <AccountCircle
                      color="primary"
                      sx={{ mr: 1, height: 20, width: 20 }}
                    />{" "}
                    Profile
                  </MenuItem>
                </Link>
                <Link to="/my-stories">
                  <MenuItem onClick={handleClose}>
                    <MenuBook
                      color="primary"
                      sx={{ mr: 1, height: 20, width: 20 }}
                    />
                    My Stories
                  </MenuItem>
                </Link>
                <Link to="/change-password">
                  <MenuItem onClick={handleClose}>
                    <Lock
                      color="primary"
                      sx={{ mr: 1, height: 20, width: 20 }}
                    />
                    Change Password
                  </MenuItem>
                </Link>
                <MenuItem onClick={logout}>
                  <Logout
                    color="primary"
                    sx={{ mr: 1, height: 20, width: 20 }}
                  />{" "}
                  Logout
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
        <SideBar open={open} setOpen={setOpen} categories={categories} />
      </Box>
      <Grid
        container
        direction="row"
        className="bg-neutral-50 border-b-2 border-gray-200"
        alignItems="center"
        p={1}
      >
        <Grid
          item
          xs={12}
          md={6}
          className="p-0 md:p-2 hidden lg:block xl:block"
        >
          <Link to="/">
            <img src={logo} className="w-44" alt="logo" />
          </Link>
        </Grid>
        <Grid item xs={12} md={6} p={0}>
          {banner ? (
            <img
              src={banner?.image_url}
              alt="banner"
              className="w-screen h-24 p-0 md:p-2"
            />
          ) : (
            <Skeleton className="w-screen h-24 p-0 md:p-2"/>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
